import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-warning mb-4"
}
const _hoisted_3 = { class: "text-primary fw-semibold mb-3" }
const _hoisted_4 = { class: "corrections-list" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "fw-semibold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "mb-0 small text-muted" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_12 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_13 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_15 = { class: "text-primary fw-bold mb-0" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "row g-4" }
const _hoisted_18 = { class: "card border shadow-sm" }
const _hoisted_19 = { class: "card-header bg-light d-flex justify-content-between align-items-center py-3" }
const _hoisted_20 = { class: "d-flex align-items-center gap-3" }
const _hoisted_21 = { class: "badge bg-primary fs-6" }
const _hoisted_22 = { class: "text-dark" }
const _hoisted_23 = ["onClick", "disabled"]
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "row g-3 mb-4" }
const _hoisted_26 = { class: "col-md-6" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "row g-3 mb-4" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_31 = { class: "col-md-4" }
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "input-group" }
const _hoisted_35 = ["value"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 0,
  class: "row g-3 mb-4"
}
const _hoisted_39 = { class: "col-md-12" }
const _hoisted_40 = { class: "alert alert-danger text-center py-3 px-4" }
const _hoisted_41 = { class: "text-start" }
const _hoisted_42 = {
  key: 1,
  class: "alert alert-warning mt-3"
}
const _hoisted_43 = ["id"]
const _hoisted_44 = { class: "accordion-item border" }
const _hoisted_45 = { class: "accordion-header" }
const _hoisted_46 = ["data-bs-target", "aria-controls"]
const _hoisted_47 = {
  class: "ms-3 badge",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_48 = ["id", "data-bs-parent"]
const _hoisted_49 = { class: "accordion-body bg-light" }
const _hoisted_50 = { class: "d-flex justify-content-between align-items-center gap-3 flex-wrap mb-4" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_53 = {
  class: "fw-bold mb-3",
  style: {"color":"#0a59a4"}
}
const _hoisted_54 = { class: "table-responsive" }
const _hoisted_55 = { class: "table table-hover table-bordered bg-white" }
const _hoisted_56 = { class: "text-primary" }
const _hoisted_57 = { class: "text-end" }
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = { class: "text-center" }
const _hoisted_60 = ["onClick", "title"]
const _hoisted_61 = { class: "table-light" }
const _hoisted_62 = { class: "text-end fw-bold" }
const _hoisted_63 = { class: "text-end fw-bold" }
const _hoisted_64 = { class: "text-center fw-bold" }
const _hoisted_65 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_66 = { class: "fw-bold mb-3 text-warning" }
const _hoisted_67 = { class: "table-responsive" }
const _hoisted_68 = { class: "table table-hover table-bordered bg-light" }
const _hoisted_69 = { class: "text-muted" }
const _hoisted_70 = { class: "text-end" }
const _hoisted_71 = { class: "text-end" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = ["onClick"]
const _hoisted_74 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_75 = {
  key: 1,
  class: "mt-5 p-4 bg-light rounded border"
}
const _hoisted_76 = { class: "row g-3 text-center text-md-start" }
const _hoisted_77 = { class: "col-md-3 col-6" }
const _hoisted_78 = { class: "d-flex align-items-center gap-2 justify-content-center justify-content-md-start" }
const _hoisted_79 = { class: "fs-4" }
const _hoisted_80 = { class: "col-md-3 col-6" }
const _hoisted_81 = { class: "d-flex align-items-center gap-2 justify-content-center justify-content-md-start" }
const _hoisted_82 = { class: "fs-4" }
const _hoisted_83 = { class: "col-md-3 col-6" }
const _hoisted_84 = { class: "d-flex align-items-center gap-2 justify-content-center justify-content-md-start" }
const _hoisted_85 = { class: "fs-4" }
const _hoisted_86 = { class: "col-md-3 col-6" }
const _hoisted_87 = { class: "d-flex align-items-center gap-2 justify-content-center justify-content-md-start" }
const _hoisted_88 = { class: "fs-4" }
const _hoisted_89 = { class: "d-flex flex-column flex-md-row justify-content-between align-items-center mt-5 pt-4 border-top gap-3" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = {
  key: 0,
  class: "modal-backdrop fade show",
  style: {"z-index":"1070"}
}
const _hoisted_94 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"z-index":"1071"}
}
const _hoisted_95 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_96 = { class: "modal-content" }
const _hoisted_97 = { class: "modal-header bg-primary text-white" }
const _hoisted_98 = { class: "modal-title text-white" }
const _hoisted_99 = { class: "modal-body" }
const _hoisted_100 = { class: "alert alert-info mb-4" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "table-responsive" }
const _hoisted_103 = { class: "table table-bordered table-sm" }
const _hoisted_104 = { class: "text-end" }
const _hoisted_105 = { class: "text-end" }
const _hoisted_106 = {
  key: 1,
  class: "alert alert-warning"
}
const _hoisted_107 = { class: "modal-footer" }
const _hoisted_108 = {
  key: 2,
  class: "modal-backdrop fade show conteneur-backdrop"
}
const _hoisted_109 = {
  key: 3,
  class: "modal fade show d-block conteneur-modal",
  tabindex: "-1"
}
const _hoisted_110 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_111 = { class: "modal-content" }
const _hoisted_112 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_113 = { class: "modal-title text-white" }
const _hoisted_114 = { class: "modal-body" }
const _hoisted_115 = { class: "row g-3" }
const _hoisted_116 = { class: "col-md-6" }
const _hoisted_117 = { class: "col-md-6" }
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = { class: "col-md-6" }
const _hoisted_121 = { class: "input-group" }
const _hoisted_122 = ["value"]
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { key: 1 }
const _hoisted_125 = { class: "col-md-6" }
const _hoisted_126 = { class: "col-12" }
const _hoisted_127 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_128 = { class: "form-check" }
const _hoisted_129 = { class: "d-flex gap-2" }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = {
  key: 4,
  class: "modal-backdrop fade show marchandise-backdrop"
}
const _hoisted_132 = {
  key: 5,
  class: "modal fade show d-block marchandise-modal",
  tabindex: "-1"
}
const _hoisted_133 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_134 = { class: "modal-content" }
const _hoisted_135 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_136 = { class: "modal-title text-white" }
const _hoisted_137 = { class: "modal-body" }
const _hoisted_138 = { class: "row g-3" }
const _hoisted_139 = { class: "col-md-4" }
const _hoisted_140 = { class: "col-md-4" }
const _hoisted_141 = { class: "col-md-4" }
const _hoisted_142 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_143 = { class: "d-flex gap-2" }
const _hoisted_144 = {
  key: 0,
  class: "alert alert-success mt-2"
}
const _hoisted_145 = {
  key: 1,
  class: "col-12"
}
const _hoisted_146 = { class: "alert alert-info" }
const _hoisted_147 = { class: "col-md-4" }
const _hoisted_148 = { class: "col-md-4" }
const _hoisted_149 = {
  key: 2,
  class: "col-12"
}
const _hoisted_150 = { class: "d-flex align-items-center mb-2" }
const _hoisted_151 = { class: "fw-bold mb-0" }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = { key: 1 }
const _hoisted_154 = { key: 2 }
const _hoisted_155 = { key: 3 }
const _hoisted_156 = { class: "mb-2" }
const _hoisted_157 = { class: "small mb-2" }
const _hoisted_158 = { key: 0 }
const _hoisted_159 = {
  key: 1,
  class: "ms-3"
}
const _hoisted_160 = {
  key: 0,
  class: "small mb-2"
}
const _hoisted_161 = { key: 0 }
const _hoisted_162 = {
  key: 1,
  class: "ms-3"
}
const _hoisted_163 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_164 = {
  key: 2,
  class: "mb-2"
}
const _hoisted_165 = { class: "col-md-4" }
const _hoisted_166 = { class: "col-md-4" }
const _hoisted_167 = { class: "col-md-4" }
const _hoisted_168 = { class: "col-md-4" }
const _hoisted_169 = { class: "col-md-6" }
const _hoisted_170 = { class: "col-md-6" }
const _hoisted_171 = {
  key: 0,
  class: "alert alert-danger mt-2 py-2 px-3"
}
const _hoisted_172 = { class: "col-12" }
const _hoisted_173 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_174 = { class: "form-check" }
const _hoisted_175 = { class: "d-flex gap-2" }
const _hoisted_176 = ["disabled"]
const _hoisted_177 = {
  key: 6,
  class: "modal-backdrop fade show",
  style: {"z-index":"1040"}
}
const _hoisted_178 = {
  key: 7,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"z-index":"1041"}
}
const _hoisted_179 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_180 = { class: "modal-content" }
const _hoisted_181 = { class: "modal-header bg-primary text-white" }
const _hoisted_182 = { class: "modal-title text-white" }
const _hoisted_183 = { class: "modal-body" }
const _hoisted_184 = {
  key: 0,
  class: "alert alert-info mb-4"
}
const _hoisted_185 = { class: "row" }
const _hoisted_186 = { class: "col-md-3" }
const _hoisted_187 = { class: "col-md-3" }
const _hoisted_188 = { class: "col-md-3" }
const _hoisted_189 = { class: "col-md-3" }
const _hoisted_190 = { class: "fw-bold mb-3" }
const _hoisted_191 = { class: "table-responsive" }
const _hoisted_192 = { class: "table table-hover table-bordered" }
const _hoisted_193 = { class: "fw-semibold" }
const _hoisted_194 = { class: "text-muted" }
const _hoisted_195 = { class: "text-end" }
const _hoisted_196 = { class: "text-end" }
const _hoisted_197 = { class: "text-end" }
const _hoisted_198 = { class: "text-end" }
const _hoisted_199 = { class: "text-muted" }
const _hoisted_200 = ["onClick"]
const _hoisted_201 = ["onClick"]
const _hoisted_202 = { class: "table-light" }
const _hoisted_203 = { class: "text-end fw-bold" }
const _hoisted_204 = {
  colspan: "4",
  class: "text-end fw-bold"
}
const _hoisted_205 = {
  colspan: "2",
  class: "text-center fw-bold"
}
const _hoisted_206 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.corrections.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h6", _hoisted_3, [
              _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
              _createTextVNode(" Corrections demandées (" + _toDisplayString(_ctx.corrections.length) + ") ", 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corrections, (correction) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: correction.id,
                  class: "d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded"
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("small", _hoisted_6, [
                      (typeof correction.fields_concerned === 'object')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(Object.keys(correction.fields_concerned).join(', ')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(correction.fields_concerned), 1))
                    ]),
                    _createElementVNode("p", _hoisted_9, _toDisplayString(correction.message_to_requester), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.markCorrectionAsFixed(correction.id)),
                    class: "btn btn-success btn-sm"
                  }, [...(_cache[33] || (_cache[33] = [
                    _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1),
                    _createTextVNode(" Corrigé ", -1)
                  ]))], 8, _hoisted_10)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[75] || (_cache[75] = _createElementVNode("div", {
        class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
        style: {"background-color":"#0a59a4"}
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-white fw-bold mb-1" }, "Modification - Étape 2 – Gestion des Bills of Lading (BL)"),
          _createElementVNode("small", { class: "text-white opacity-75" }, "Modifiez les BLs associés à ce dossier BESC")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.chargementDonnees)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
              ], -1),
              _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement des BLs existants...", -1)
            ]))]))
          : (_openBlock(), _createBlock(_component_Form, {
              key: 1,
              ref: "blForm",
              onSubmit: _ctx.mettreAJour,
              "validation-schema": _ctx.blSchema
            }, {
              default: _withCtx(() => [
                (_ctx.listeBLs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h5", _hoisted_15, [
                          _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-file-invoice me-2" }, null, -1)),
                          _createTextVNode(" Bills of Lading (" + _toDisplayString(_ctx.listeBLs.length) + ") ", 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["btn btn-sm", _ctx.peutAjouterBL ? 'btn-success' : 'btn-secondary']),
                          disabled: !_ctx.peutAjouterBL,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ajouterBL && _ctx.ajouterBL(...args)))
                        }, [...(_cache[36] || (_cache[36] = [
                          _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
                          _createTextVNode("Ajouter un BL ", -1)
                        ]))], 10, _hoisted_16)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listeBLs, (bl, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: bl.id || index,
                            class: "col-12"
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("span", _hoisted_21, "BL #" + _toDisplayString(index + 1), 1),
                                  _createElementVNode("strong", _hoisted_22, _toDisplayString(bl.numeroBL || '(Non renseigné)'), 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-danger btn-sm",
                                  onClick: ($event: any) => (_ctx.supprimerBL(index)),
                                  disabled: _ctx.listeBLs.length === 1
                                }, [...(_cache[37] || (_cache[37] = [
                                  _createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1),
                                  _createTextVNode(" Supprimer ", -1)
                                ]))], 8, _hoisted_23)
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "section-title mb-4" }, [
                                  _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                    _createTextVNode("Informations du BL ")
                                  ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _cache[38] || (_cache[38] = _createElementVNode("label", { class: "text-black fw-semibold mb-2" }, [
                                      _createTextVNode("Numéro de BL "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ], -1)),
                                    _createVNode(_component_Field, {
                                      name: `listeBLs[${index}].numeroBL`,
                                      modelValue: bl.numeroBL,
                                      "onUpdate:modelValue": ($event: any) => ((bl.numeroBL) = $event),
                                      type: "text",
                                      class: "form-control shadow-sm",
                                      placeholder: "ex: MAEU123456789",
                                      onBlur: () => _ctx.validerBL(index)
                                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onBlur"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: `listeBLs[${index}].numeroBL`,
                                      class: "text-danger small mt-1 d-block"
                                    }, null, 8, ["name"])
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _cache[39] || (_cache[39] = _createElementVNode("label", { class: "text-black fw-semibold mb-2" }, "Référence de voyage", -1)),
                                    _createVNode(_component_Field, {
                                      name: `listeBLs[${index}].referenceVoyage`,
                                      modelValue: bl.referenceVoyage,
                                      "onUpdate:modelValue": ($event: any) => ((bl.referenceVoyage) = $event),
                                      type: "text",
                                      class: "form-control shadow-sm",
                                      placeholder: "ex: 024E"
                                    }, null, 8, ["name", "modelValue", "onUpdate:modelValue"])
                                  ])
                                ]),
                                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "section-title mb-4" }, [
                                  _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                                    _createElementVNode("i", { class: "fas fa-ship me-2" }),
                                    _createTextVNode("Informations de transport ")
                                  ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _cache[40] || (_cache[40] = _createElementVNode("label", { class: "text-black fw-semibold mb-2" }, [
                                      _createTextVNode("Compagnie maritime "),
                                      _createElementVNode("span", { class: "text-danger" }, "*")
                                    ], -1)),
                                    _createVNode(_component_Field, {
                                      name: `listeBLs[${index}].idCompagnie`,
                                      modelValue: _ctx.listeBLs[index].idCompagnie,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.listeBLs[index].idCompagnie) = $event)
                                    }, {
                                      default: _withCtx(({ field, errorMessage }) => [
                                        _createVNode(_component_Multiselect, _mergeProps({ ref_for: true }, field, {
                                          options: _ctx.compagniesMaritimes,
                                          searchable: true,
                                          loading: _ctx.chargementCompagnies,
                                          placeholder: "Rechercher (code)...",
                                          label: "label",
                                          "track-by": "value",
                                          valueProp: "value",
                                          onSearchChange: _ctx.rechercherCompagnie,
                                          "filter-results": false,
                                          "min-chars": 2
                                        }), null, 16, ["options", "loading", "onSearchChange"]),
                                        errorMessage
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_30, _toDisplayString(errorMessage), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["name", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "text-black fw-semibold mb-2" }, "Navire", -1)),
                                    _createVNode(_component_Field, {
                                      name: `listeBLs[${index}].idNavire`,
                                      modelValue: _ctx.listeBLs[index].idNavire,
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.listeBLs[index].idNavire) = $event)
                                    }, {
                                      default: _withCtx(({ field, errorMessage, setValue }) => [
                                        _createVNode(_component_Multiselect, _mergeProps({ ref_for: true }, field, {
                                          options: _ctx.listeNavires,
                                          searchable: true,
                                          loading: _ctx.chargementNavires,
                                          placeholder: "Rechercher (IMO/MMSI)...",
                                          label: "label",
                                          "track-by": "value",
                                          valueProp: "value",
                                          onSearchChange: _ctx.rechercherNavire,
                                          "filter-results": false,
                                          "min-chars": 2,
                                          "onUpdate:modelValue": async (val) => {
                            setValue(val);
                            const navire = _ctx.listeNavires.find(n => n.value === val);
                            if (navire?.imo) {
                              const result = await _ctx.checkBlacklist('SHIP', navire.imo);
                              if (result.isBlacklisted) {
                                _ctx.blacklistAlerts.navires[index] = result.details;
                              } else {
                                delete _ctx.blacklistAlerts.navires[index];
                              }
                            } else {
                              delete _ctx.blacklistAlerts.navires[index];
                            }
                          }
                                        }), null, 16, ["options", "loading", "onSearchChange", "onUpdate:modelValue"]),
                                        errorMessage
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_32, _toDisplayString(errorMessage), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["name", "modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "text-black fw-semibold mb-2" }, [
                                      _createTextVNode(" Poids brut total (Tonnes) "),
                                      _createElementVNode("span", { class: "text-muted" }, "(calculé auto)")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createElementVNode("input", {
                                        type: "number",
                                        value: _ctx.calculerPoidsBrutBL(bl).toFixed(2),
                                        class: "form-control bg-light fw-bold",
                                        readonly: "",
                                        disabled: ""
                                      }, null, 8, _hoisted_35),
                                      _createElementVNode("span", {
                                        class: _normalizeClass(["input-group-text", _ctx.calculerPoidsBrutBL(bl) > 0 ? 'bg-success text-white' : 'bg-secondary text-white'])
                                      }, [...(_cache[42] || (_cache[42] = [
                                        _createElementVNode("i", { class: "fas fa-weight-hanging" }, null, -1)
                                      ]))], 2)
                                    ]),
                                    _createElementVNode("small", {
                                      class: _normalizeClass(["d-block mt-2", _ctx.calculerPoidsBrutBL(bl) > 0 ? 'text-success' : 'text-warning'])
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass(["fas", _ctx.calculerPoidsBrutBL(bl) > 0 ? 'fa-check-circle' : 'fa-info-circle'])
                                      }, null, 2),
                                      (_ctx.calculerPoidsBrutBL(bl) > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, " Calculé depuis " + _toDisplayString(bl.marchandises?.length || 0) + " marchandise(s) ", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_37, " Ajoutez des marchandises pour calculer le poids "))
                                    ], 2)
                                  ])
                                ]),
                                (_ctx.blacklistAlerts.navires[index])
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                      _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("div", _hoisted_40, [
                                          _cache[45] || (_cache[45] = _createElementVNode("h6", { class: "fw-bold mb-2" }, [
                                            _createElementVNode("i", { class: "ph-warning-circle fs-4" }),
                                            _createTextVNode(" ⚠️ ALERTE BLACKLIST - NAVIRE ")
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_41, [
                                            _cache[44] || (_cache[44] = _createElementVNode("strong", null, "Navire:", -1)),
                                            _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.navires[index].list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.navires[index].reason), 1)
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (bl.erreurs?.marchandises)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _cache[46] || (_cache[46] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(bl.erreurs.marchandises), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", {
                                  class: "accordion mt-4",
                                  id: `accordéonBL-${index}`
                                }, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("h2", _hoisted_45, [
                                      _createElementVNode("button", {
                                        class: "accordion-button collapsed fw-semibold",
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": `#contenuBL-${index}`,
                                        "aria-controls": `contenuBL-${index}`,
                                        "aria-expanded": "false",
                                        style: {"background-color":"#f8f9fa"}
                                      }, [
                                        _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fas fa-boxes me-2 text-primary" }, null, -1)),
                                        _cache[48] || (_cache[48] = _createTextVNode(" Gestion des marchandises et conteneurs ", -1)),
                                        _createElementVNode("span", _hoisted_47, _toDisplayString(bl.marchandises?.length || 0) + " marchandise(s)", 1)
                                      ], 8, _hoisted_46)
                                    ]),
                                    _createElementVNode("div", {
                                      id: `contenuBL-${index}`,
                                      class: "accordion-collapse collapse",
                                      "data-bs-parent": `#accordéonBL-${index}`
                                    }, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _createElementVNode("div", _hoisted_50, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-info shadow-sm",
                                            onClick: ($event: any) => (_ctx.ouvrirModalMarchandise(index))
                                          }, [...(_cache[49] || (_cache[49] = [
                                            _createElementVNode("i", { class: "fas fa-box me-2" }, null, -1),
                                            _createTextVNode("Ajouter une marchandise ", -1)
                                          ]))], 8, _hoisted_51)
                                        ]),
                                        (bl.marchandises && bl.marchandises.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _createElementVNode("h6", _hoisted_53, [
                                                _cache[50] || (_cache[50] = _createElementVNode("i", { class: "fas fa-container-storage me-2" }, null, -1)),
                                                _createTextVNode(" Conteneurs (" + _toDisplayString(_ctx.calculerConteneurUniques(bl)) + ") ", 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("table", _hoisted_55, [
                                                  _cache[54] || (_cache[54] = _createElementVNode("thead", { class: "table-info" }, [
                                                    _createElementVNode("tr", null, [
                                                      _createElementVNode("th", null, "N°"),
                                                      _createElementVNode("th", null, "Numéro Conteneur"),
                                                      _createElementVNode("th", null, "Type"),
                                                      _createElementVNode("th", null, "Scellé"),
                                                      _createElementVNode("th", null, "Type Chargement"),
                                                      _createElementVNode("th", null, "Poids Brut (Tonnes)"),
                                                      _createElementVNode("th", null, "Volume (m³)"),
                                                      _createElementVNode("th", null, "Marchandises Associées")
                                                    ])
                                                  ], -1)),
                                                  _createElementVNode("tbody", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtenirConteneursUniques(bl), (conteneur, cIndex) => {
                                                      return (_openBlock(), _createElementBlock("tr", { key: cIndex }, [
                                                        _createElementVNode("td", null, _toDisplayString(cIndex + 1), 1),
                                                        _createElementVNode("td", null, [
                                                          _createElementVNode("strong", _hoisted_56, _toDisplayString(conteneur.numeroConteneur), 1)
                                                        ]),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.typeConteneurs.find(t => t.value === conteneur.typeConteneur)?.label || '-'), 1),
                                                        _createElementVNode("td", null, _toDisplayString(conteneur.numeroScelle || '-'), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.typeChargements.find(t => t.value === conteneur.typeChargement)?.label || '-'), 1),
                                                        _createElementVNode("td", _hoisted_57, _toDisplayString(conteneur.poidsBrut?.toFixed(2) || '0.00'), 1),
                                                        _createElementVNode("td", _hoisted_58, _toDisplayString(conteneur.volume?.toFixed(2) || '-'), 1),
                                                        _createElementVNode("td", _hoisted_59, [
                                                          _createElementVNode("button", {
                                                            type: "button",
                                                            class: "btn btn-sm btn-outline-success",
                                                            onClick: ($event: any) => (_ctx.afficherMarchandisesConteneur(index, conteneur.numeroConteneur)),
                                                            title: `Voir les ${conteneur.marchandises.length} marchandise(s)`
                                                          }, [
                                                            _cache[51] || (_cache[51] = _createElementVNode("i", { class: "fas fa-boxes me-1" }, null, -1)),
                                                            _createTextVNode(" " + _toDisplayString(conteneur.marchandises.length) + " marchandise(s) ", 1)
                                                          ], 8, _hoisted_60)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]),
                                                  _createElementVNode("tfoot", _hoisted_61, [
                                                    _createElementVNode("tr", null, [
                                                      _cache[53] || (_cache[53] = _createElementVNode("td", {
                                                        colspan: "5",
                                                        class: "text-end fw-bold"
                                                      }, "Total:", -1)),
                                                      _createElementVNode("td", _hoisted_62, _toDisplayString(bl.marchandises.reduce((sum, m) => sum + (m.poidsBrut || 0), 0).toFixed(2)) + " tonnes ", 1),
                                                      _createElementVNode("td", _hoisted_63, _toDisplayString(bl.marchandises.reduce((sum, m) => sum + (m.valeurDeclaree || 0), 0).toFixed(2)) + " USD ", 1),
                                                      _createElementVNode("td", _hoisted_64, [
                                                        _cache[52] || (_cache[52] = _createElementVNode("i", { class: "fas fa-boxes me-1" }, null, -1)),
                                                        _createTextVNode(" " + _toDisplayString(bl.marchandises.length) + " marchandise(s) total ", 1)
                                                      ])
                                                    ])
                                                  ])
                                                ])
                                              ]),
                                              (_ctx.obtenirMarchandisesVrac(bl).length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                                    _createElementVNode("h6", _hoisted_66, [
                                                      _cache[55] || (_cache[55] = _createElementVNode("i", { class: "fas fa-box-open me-2" }, null, -1)),
                                                      _createTextVNode(" Marchandises en vrac (" + _toDisplayString(_ctx.obtenirMarchandisesVrac(bl).length) + ") ", 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_67, [
                                                      _createElementVNode("table", _hoisted_68, [
                                                        _cache[58] || (_cache[58] = _createElementVNode("thead", { class: "table-warning" }, [
                                                          _createElementVNode("tr", null, [
                                                            _createElementVNode("th", null, "N°"),
                                                            _createElementVNode("th", null, "Description"),
                                                            _createElementVNode("th", null, "Code HS"),
                                                            _createElementVNode("th", null, "Type Conditionnement"),
                                                            _createElementVNode("th", null, "Poids (Tonnes)"),
                                                            _createElementVNode("th", null, "Valeur"),
                                                            _createElementVNode("th", null, "Actions")
                                                          ])
                                                        ], -1)),
                                                        _createElementVNode("tbody", null, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.obtenirMarchandisesVrac(bl), (marchandise) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: marchandise.originalIndex
                                                            }, [
                                                              _createElementVNode("td", null, _toDisplayString(marchandise.originalIndex + 1), 1),
                                                              _createElementVNode("td", null, _toDisplayString(marchandise.description), 1),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("small", _hoisted_69, _toDisplayString(typeof marchandise.hscode === 'object'
                                              ? (marchandise.hscode?.label || `${marchandise.hscode?.code} - ${marchandise.hscode?.product}`)
                                              : _ctx.hsCodes.find(h => h.value === marchandise.hscode)?.label || '-'), 1)
                                                              ]),
                                                              _createElementVNode("td", null, _toDisplayString(marchandise.nombreColis) + " " + _toDisplayString(_ctx.typeConditionnements.find(t => t.value === marchandise.typeConditionnement)?.label || '-'), 1),
                                                              _createElementVNode("td", _hoisted_70, _toDisplayString(marchandise.poidsBrut.toFixed(2)), 1),
                                                              _createElementVNode("td", _hoisted_71, _toDisplayString(marchandise.valeurDeclaree.toFixed(2)) + " " + _toDisplayString(marchandise.devise), 1),
                                                              _createElementVNode("td", null, [
                                                                _createElementVNode("button", {
                                                                  type: "button",
                                                                  class: "btn btn-outline-primary btn-sm",
                                                                  onClick: ($event: any) => (_ctx.modifierMarchandise(index, marchandise.originalIndex)),
                                                                  title: "Modifier"
                                                                }, [...(_cache[56] || (_cache[56] = [
                                                                  _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                                                                ]))], 8, _hoisted_72),
                                                                _createElementVNode("button", {
                                                                  type: "button",
                                                                  class: "btn btn-outline-danger btn-sm",
                                                                  onClick: ($event: any) => (_ctx.supprimerMarchandise(index, marchandise.originalIndex)),
                                                                  title: "Supprimer"
                                                                }, [...(_cache[57] || (_cache[57] = [
                                                                  _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                                                ]))], 8, _hoisted_73)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ])
                                                      ])
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (!bl.marchandises || !bl.marchandises.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [...(_cache[59] || (_cache[59] = [
                                              _createElementVNode("div", { class: "alert alert-info" }, [
                                                _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                                                _createElementVNode("strong", null, "Aucune marchandise ajoutée"),
                                                _createElementVNode("p", { class: "mb-0 mt-2 small" }, "Cliquez sur \"Ajouter une marchandise\" pour commencer.")
                                              ], -1)
                                            ]))]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], 8, _hoisted_48)
                                  ])
                                ], 8, _hoisted_43)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.listeBLs.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                      _cache[71] || (_cache[71] = _createElementVNode("h6", { class: "fw-bold mb-3" }, [
                        _createElementVNode("i", { class: "fas fa-chart-bar me-2" }),
                        _createTextVNode("Résumé")
                      ], -1)),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("div", _hoisted_78, [
                            _cache[63] || (_cache[63] = _createElementVNode("i", { class: "fas fa-file-invoice text-primary fs-4" }, null, -1)),
                            _createElementVNode("div", null, [
                              _cache[62] || (_cache[62] = _createElementVNode("small", { class: "text-muted d-block" }, "Total BLs", -1)),
                              _createElementVNode("strong", _hoisted_79, _toDisplayString(_ctx.listeBLs.length), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("div", _hoisted_81, [
                            _cache[65] || (_cache[65] = _createElementVNode("i", { class: "fas fa-weight text-success fs-4" }, null, -1)),
                            _createElementVNode("div", null, [
                              _cache[64] || (_cache[64] = _createElementVNode("small", { class: "text-muted d-block" }, "Poids total", -1)),
                              _createElementVNode("strong", _hoisted_82, _toDisplayString(_ctx.poidsTotalBrut.toFixed(2)) + " tonnes", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _cache[67] || (_cache[67] = _createElementVNode("i", { class: "fas fa-ship text-warning fs-4" }, null, -1)),
                            _createElementVNode("div", null, [
                              _cache[66] || (_cache[66] = _createElementVNode("small", { class: "text-muted d-block" }, "Compagnies", -1)),
                              _createElementVNode("strong", _hoisted_85, _toDisplayString(_ctx.nombreCompagniesUniques), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _cache[70] || (_cache[70] = _createElementVNode("i", { class: "fas fa-check-circle text-info fs-4" }, null, -1)),
                            _createElementVNode("div", null, [
                              _cache[68] || (_cache[68] = _createElementVNode("small", { class: "text-muted d-block" }, "BLs complets", -1)),
                              _createElementVNode("strong", _hoisted_88, _toDisplayString(_ctx.nombreBLValides) + " / " + _toDisplayString(_ctx.listeBLs.length), 1),
                              _cache[69] || (_cache[69] = _createElementVNode("small", {
                                class: "d-block text-muted",
                                style: {"font-size":"0.7rem"}
                              }, " (avec marchandises) ", -1))
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_89, [
                  _createVNode(_component_router_link, {
                    to: { name: 'EditAddBescStep1', params: { id: _ctx.bescId } },
                    class: "btn btn-danger px-4"
                  }, {
                    default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                      _createTextVNode(" Retour à l'étape 1 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["to"]),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary px-5 py-2",
                    disabled: !_ctx.peutContinuer || _ctx.enregistrementEnCours
                  }, [
                    (_ctx.enregistrementEnCours)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_91, [...(_cache[73] || (_cache[73] = [
                          _createElementVNode("i", { class: "fas fa-spinner fa-spin me-2" }, null, -1),
                          _createTextVNode(" Mise à jour... ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_92, [...(_cache[74] || (_cache[74] = [
                          _createElementVNode("i", { class: "fas fa-save me-2" }, null, -1),
                          _createTextVNode(" Mettre à jour & Passer à l'étape 3 ", -1)
                        ]))]))
                  ], 8, _hoisted_90)
                ])
              ]),
              _: 1
            }, 8, ["onSubmit", "validation-schema"]))
      ])
    ]),
    (_ctx.afficherModalVoirConteneurs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_93))
      : _createCommentVNode("", true),
    (_ctx.afficherModalVoirConteneurs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("h5", _hoisted_98, [
                  _cache[76] || (_cache[76] = _createElementVNode("i", { class: "fas fa-container-storage me-2" }, null, -1)),
                  _createTextVNode(" Conteneur de la marchandise " + _toDisplayString((_ctx.marchandiseSelectionnee?.index ?? 0) + 1), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fermerModalVoirConteneurs && _ctx.fermerModalVoirConteneurs(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _cache[77] || (_cache[77] = _createElementVNode("strong", null, "Marchandise :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.marchandiseSelectionnee?.data.description) + " ", 1),
                  _cache[78] || (_cache[78] = _createElementVNode("br", null, null, -1)),
                  _cache[79] || (_cache[79] = _createElementVNode("strong", null, "Type :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.typeConditionnements.find(t => t.value ===
              _ctx.marchandiseSelectionnee?.data.typeConditionnement)?.label) + " ", 1),
                  _cache[80] || (_cache[80] = _createElementVNode("br", null, null, -1)),
                  _cache[81] || (_cache[81] = _createElementVNode("strong", null, "Poids :", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.marchandiseSelectionnee?.data.poidsBrut?.toFixed(2)) + " tonnes ", 1)
                ]),
                _cache[84] || (_cache[84] = _createElementVNode("h6", { class: "fw-bold mb-3" }, [
                  _createElementVNode("i", { class: "fas fa-list me-2" }),
                  _createTextVNode(" Conteneur associé ")
                ], -1)),
                ((_ctx.marchandiseSelectionnee?.data as any)?.conteneur)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _createElementVNode("table", _hoisted_103, [
                          _cache[82] || (_cache[82] = _createElementVNode("thead", { class: "table-light" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "N° Conteneur"),
                              _createElementVNode("th", null, "Type"),
                              _createElementVNode("th", null, "Scellé"),
                              _createElementVNode("th", null, "Type chargement"),
                              _createElementVNode("th", null, "Poids brut (Tonnes)"),
                              _createElementVNode("th", null, "Volume (m³)")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, [
                                _createElementVNode("strong", null, _toDisplayString((_ctx.marchandiseSelectionnee?.data as any)?.conteneur?.numeroConteneur), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.typeConteneurs.find(t => t.value === (_ctx.marchandiseSelectionnee?.data as
                      any)?.conteneur?.typeConteneur)?.label || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString((_ctx.marchandiseSelectionnee?.data as any)?.conteneur?.numeroScelle || '-'), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.typeChargements.find(t => t.value === (_ctx.marchandiseSelectionnee?.data as
                      any)?.conteneur?.typeChargement)?.label || '-'), 1),
                              _createElementVNode("td", _hoisted_104, _toDisplayString((_ctx.marchandiseSelectionnee?.data as any)?.conteneur?.poidsBrut?.toFixed(2) ||
                      '0.00'), 1),
                              _createElementVNode("td", _hoisted_105, _toDisplayString((_ctx.marchandiseSelectionnee?.data as any)?.conteneur?.volume?.toFixed(2) || '-'), 1)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_106, [...(_cache[83] || (_cache[83] = [
                      _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1),
                      _createTextVNode(" Aucun conteneur associé à cette marchandise ", -1)
                    ]))]))
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.fermerModalVoirConteneurs && _ctx.fermerModalVoirConteneurs(...args)))
                }, " Fermer ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.afficherModalConteneur)
      ? (_openBlock(), _createElementBlock("div", _hoisted_108))
      : _createCommentVNode("", true),
    (_ctx.afficherModalConteneur)
      ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
          _createElementVNode("div", _hoisted_110, [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", _hoisted_112, [
                _createElementVNode("h5", _hoisted_113, " Ajouter un conteneur – BL " + _toDisplayString(_ctx.blActuel?.numeroBL || 'N/A'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fermerModalConteneur && _ctx.fermerModalConteneur(...args)))
                })
              ]),
              _createVNode(_component_Form, {
                onSubmit: _ctx.enregistrerConteneur,
                "validation-schema": _ctx.conteneurSchema
              }, {
                default: _withCtx(({ isSubmitting }) => [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _cache[85] || (_cache[85] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" N° Conteneur "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "numeroConteneur",
                          modelValue: _ctx.nouveauConteneur.numeroConteneur,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.nouveauConteneur.numeroConteneur) = $event)),
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "ex: MSCU1234567"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numeroConteneur",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_117, [
                        _cache[86] || (_cache[86] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" N° Scellé "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "numeroScelle",
                          modelValue: _ctx.nouveauConteneur.numeroScelle,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.nouveauConteneur.numeroScelle) = $event)),
                          type: "text",
                          class: "form-control shadow-none fs-md-15 text-black",
                          placeholder: "ex: 123456789"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "numeroScelle",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_118, [
                        _cache[87] || (_cache[87] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Type de conteneur "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "typeConteneur",
                          modelValue: _ctx.nouveauConteneur.typeConteneur,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.nouveauConteneur.typeConteneur) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.typeConteneurs,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              placeholder: "Sélectionner...",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "loading"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "typeConteneur",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _cache[88] || (_cache[88] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Type de chargement "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "typeChargement",
                          modelValue: _ctx.nouveauConteneur.typeChargement,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.nouveauConteneur.typeChargement) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.typeChargements,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              placeholder: "Sélectionner...",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "loading"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "typeChargement",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_120, [
                        _cache[90] || (_cache[90] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Poids brut (Tonnes) "),
                          _createElementVNode("span", { class: "text-muted" }, "(calculé auto)")
                        ], -1)),
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("input", {
                            type: "number",
                            value: _ctx.poidsBrutConteneurCalcule.toFixed(2),
                            class: "form-control bg-light fw-bold",
                            readonly: "",
                            disabled: ""
                          }, null, 8, _hoisted_122),
                          _createElementVNode("span", {
                            class: _normalizeClass(["input-group-text", _ctx.poidsBrutConteneurCalcule > 0 ? 'bg-success text-white' : 'bg-secondary text-white'])
                          }, [...(_cache[89] || (_cache[89] = [
                            _createElementVNode("i", { class: "fas fa-weight-hanging" }, null, -1)
                          ]))], 2)
                        ]),
                        _createElementVNode("small", {
                          class: _normalizeClass(["d-block mt-2", _ctx.poidsBrutConteneurCalcule > 0 ? 'text-success' : 'text-warning'])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(["fas", _ctx.poidsBrutConteneurCalcule > 0 ? 'fa-check-circle' : 'fa-info-circle'])
                          }, null, 2),
                          (_ctx.poidsBrutConteneurCalcule > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_123, " Poids calculé: " + _toDisplayString(_ctx.poidsBrutConteneurCalcule.toFixed(2)) + " tonnes ", 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_124, " Le poids sera calculé automatiquement selon la marchandise "))
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_125, [
                        _cache[91] || (_cache[91] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Volume (m³)", -1)),
                        _createVNode(_component_Field, {
                          name: "volume",
                          modelValue: _ctx.nouveauConteneur.volume,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.nouveauConteneur.volume) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "volume",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _cache[92] || (_cache[92] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1)),
                        _createVNode(_component_Field, {
                          name: "description",
                          modelValue: _ctx.nouveauConteneur.description,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.nouveauConteneur.description) = $event)),
                          as: "textarea",
                          class: "form-control shadow-none fs-md-15 text-black",
                          rows: "3",
                          placeholder: "Description du conteneur (optionnel)..."
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "description",
                          class: "text-danger small mt-1"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "dupliquerConteneur",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.garderModalConteneurOuvert) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.garderModalConteneurOuvert]
                      ]),
                      _cache[93] || (_cache[93] = _createElementVNode("label", {
                        class: "form-check-label text-muted small",
                        for: "dupliquerConteneur"
                      }, " Garder rempli pour ajouter un autre conteneur ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_129, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger",
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.fermerModalConteneur && _ctx.fermerModalConteneur(...args)))
                      }, " Annuler "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-success",
                        disabled: isSubmitting
                      }, _toDisplayString(isSubmitting ? 'Enregistrement...' : 'Enregistrer'), 9, _hoisted_130)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.afficherModalMarchandise)
      ? (_openBlock(), _createElementBlock("div", _hoisted_131))
      : _createCommentVNode("", true),
    (_ctx.afficherModalMarchandise)
      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, [
                _createElementVNode("h5", _hoisted_136, _toDisplayString(_ctx.indexMarchandiseEnEdition !== null ? 'Modifier' : 'Ajouter') + " une marchandise – BL " + _toDisplayString(_ctx.blActuel?.numeroBL
            || 'N/A'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.fermerModalMarchandise && _ctx.fermerModalMarchandise(...args)))
                })
              ]),
              _createVNode(_component_Form, {
                onSubmit: _ctx.enregistrerMarchandise,
                "validation-schema": _ctx.marchandiseSchema
              }, {
                default: _withCtx(({ isSubmitting }) => [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _createElementVNode("div", _hoisted_139, [
                        _cache[94] || (_cache[94] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Code HS (SH)", -1)),
                        _createVNode(_component_Field, {
                          name: "hscode",
                          modelValue: _ctx.nouvelleMarchandise.hscode,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.nouvelleMarchandise.hscode) = $event))
                        }, {
                          default: _withCtx(({ field, setValue }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.hsCodes,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              "onUpdate:modelValue": (val) => _ctx.onHscodeChange(val, setValue),
                              placeholder: "Rechercher HS",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "loading", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "hscode",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_140, [
                        _cache[95] || (_cache[95] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Nombre de colis "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "nombreColis",
                          modelValue: _ctx.nouvelleMarchandise.nombreColis,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.nouvelleMarchandise.nombreColis) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          min: "1",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "nombreColis",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _cache[96] || (_cache[96] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Type de conditionnement "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "typeConditionnement",
                          modelValue: _ctx.nouvelleMarchandise.typeConditionnement,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.nouvelleMarchandise.typeConditionnement) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.typeConditionnements,
                              onChange: _ctx.resetConteneursSelonType,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              placeholder: "Rechercher...",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "onChange", "loading"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "typeConditionnement",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      (_ctx.afficherSelectConteneur)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_142, [
                            _cache[100] || (_cache[100] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Conteneur associé ", -1)),
                            _createElementVNode("div", _hoisted_143, [
                              _createVNode(_component_Multiselect, {
                                modelValue: _ctx.nouvelleMarchandise.conteneurSelectionne,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.nouvelleMarchandise.conteneurSelectionne) = $event)),
                                options: _ctx.tousLesConteneursDisponiblesDuBL,
                                searchable: true,
                                placeholder: "Choisir un conteneur existant",
                                label: "label",
                                "track-by": "value",
                                class: "flex-grow-1",
                                "allow-empty": true,
                                "close-on-select": true,
                                onSelect: _ctx.ajouterConteneurExistantAMarchandise
                              }, null, 8, ["modelValue", "options", "onSelect"]),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-primary btn-sm",
                                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.ajouterConteneurALaMarchandise && _ctx.ajouterConteneurALaMarchandise(...args))),
                                title: "Ajouter un nouveau conteneur"
                              }, [...(_cache[97] || (_cache[97] = [
                                _createElementVNode("i", { class: "flaticon-plus" }, null, -1)
                              ]))])
                            ]),
                            _cache[101] || (_cache[101] = _createElementVNode("small", { class: "text-muted" }, " Pour FCL/GROUPAGE : associez un conteneur avec le bouton + ", -1)),
                            (_ctx.nouvelleMarchandise.conteneur)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                  _cache[99] || (_cache[99] = _createElementVNode("strong", null, "Conteneur associé :", -1)),
                                  _createTextVNode(" " + _toDisplayString(_ctx.nouvelleMarchandise.conteneur.numeroConteneur) + " ", 1),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-outline-danger float-end",
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.nouvelleMarchandise.conteneur = null))
                                  }, [...(_cache[98] || (_cache[98] = [
                                    _createElementVNode("i", { class: "fas fa-times" }, null, -1)
                                  ]))])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_ctx.nouvelleMarchandise.typeConditionnement)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                              _createElementVNode("div", _hoisted_146, [
                                _cache[102] || (_cache[102] = _createElementVNode("i", { class: "fas fa-info-circle me-2" }, null, -1)),
                                _createElementVNode("strong", null, _toDisplayString(_ctx.typeConditionnements.find(t => t.value === _ctx.nouvelleMarchandise.typeConditionnement)?.label), 1),
                                _cache[103] || (_cache[103] = _createElementVNode("p", { class: "mb-0 mt-2 small" }, " Les conteneurs ne sont pas nécessaires pour ce type de conditionnement. ", -1))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_147, [
                        _cache[104] || (_cache[104] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Tableau IMDG", -1)),
                        _createVNode(_component_Field, {
                          name: "tableauIMDG",
                          modelValue: _ctx.nouvelleMarchandise.tableauIMDG,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.nouvelleMarchandise.tableauIMDG) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.tableauxIMDG,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              placeholder: "Rechercher...",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "loading"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "tableauIMDG",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_148, [
                        _cache[105] || (_cache[105] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Catégorie produit", -1)),
                        _createVNode(_component_Field, {
                          name: "categorieProduit",
                          modelValue: _ctx.nouvelleMarchandise.categorieProduit,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.nouvelleMarchandise.categorieProduit) = $event))
                        }, {
                          default: _withCtx(({ field, setValue }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.categoriesProduit,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              "onUpdate:modelValue": (val) => _ctx.onCategorieProduitChange(val, setValue),
                              placeholder: "Rechercher...",
                              label: "label",
                              "track-by": "value"
                            }), null, 16, ["options", "loading", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "categorieProduit",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      (_ctx.restrictionAlerts.marchandise && _ctx.restrictionAlerts.marchandise.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restrictionAlerts.marchandise, (restriction, rIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: rIndex,
                                class: _normalizeClass([
                    'alert py-3 px-4 mb-3',
                    restriction.restriction_type === 'FORBIDDEN' ? 'alert-danger' : 
                    restriction.restriction_type === 'LICENSE_REQUIRED' ? 'alert-warning' : 
                    restriction.restriction_type === 'SPECIAL_TAX' ? 'alert-info' : 
                    'alert-secondary'
                  ])
                              }, [
                                _createElementVNode("div", _hoisted_150, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass([
                      'me-2 fs-4',
                      restriction.restriction_type === 'FORBIDDEN' ? 'ph-prohibit text-danger' : 
                      restriction.restriction_type === 'LICENSE_REQUIRED' ? 'ph-warning text-warning' : 
                      restriction.restriction_type === 'SPECIAL_TAX' ? 'ph-info text-info' : 
                      'ph-warning-circle'
                    ])
                                  }, null, 2),
                                  _createElementVNode("h6", _hoisted_151, [
                                    (restriction.restriction_type === 'FORBIDDEN')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_152, "PRODUIT INTERDIT"))
                                      : (restriction.restriction_type === 'LICENSE_REQUIRED')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_153, "LICENCE REQUISE"))
                                        : (restriction.restriction_type === 'SPECIAL_TAX')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_154, "TAXE SPÉCIALE APPLICABLE"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_155, "QUANTITÉ LIMITÉE"))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_156, [
                                  _cache[106] || (_cache[106] = _createElementVNode("strong", null, "Description:", -1)),
                                  _createTextVNode(" " + _toDisplayString(restriction.description), 1)
                                ]),
                                _createElementVNode("div", _hoisted_157, [
                                  (restriction.hscode)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_158, [
                                        _cache[107] || (_cache[107] = _createElementVNode("strong", null, "HS Code:", -1)),
                                        _createTextVNode(" " + _toDisplayString(restriction.hscode.code) + " - " + _toDisplayString(restriction.hscode.product), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (restriction.categorieProduit)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_159, [
                                        _cache[108] || (_cache[108] = _createElementVNode("strong", null, "Catégorie:", -1)),
                                        _createTextVNode(" " + _toDisplayString(restriction.categorieProduit.code) + " - " + _toDisplayString(restriction.categorieProduit.name), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (restriction.max_quantity || restriction.max_declared_value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                      (restriction.max_quantity)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_161, [
                                            _cache[109] || (_cache[109] = _createElementVNode("strong", null, "Quantité max:", -1)),
                                            _createTextVNode(" " + _toDisplayString(restriction.max_quantity) + " tonnes ", 1)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (restriction.max_declared_value)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_162, [
                                            _cache[110] || (_cache[110] = _createElementVNode("strong", null, "Valeur max:", -1)),
                                            _createTextVNode(" " + _toDisplayString(restriction.max_declared_value) + " USD ", 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (restriction.typeD)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                      _cache[111] || (_cache[111] = _createElementVNode("strong", null, "Document requis:", -1)),
                                      _createTextVNode(" " + _toDisplayString(restriction.typeD.code) + " - " + _toDisplayString(restriction.typeD.libelle), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (restriction.special_tax_rate)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_164, [
                                      _cache[112] || (_cache[112] = _createElementVNode("strong", null, "Taux de taxe spéciale:", -1)),
                                      _createTextVNode(" " + _toDisplayString(restriction.special_tax_rate) + "% ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_165, [
                        _cache[113] || (_cache[113] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Poids brut (Tonnes) "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "poidsBrut",
                          modelValue: _ctx.nouvelleMarchandise.poidsBrut,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.nouvelleMarchandise.poidsBrut) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "poidsBrut",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_166, [
                        _cache[114] || (_cache[114] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Poids net (Tonnes) "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "poidsNet",
                          modelValue: _ctx.nouvelleMarchandise.poidsNet,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.nouvelleMarchandise.poidsNet) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "poidsNet",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_167, [
                        _cache[115] || (_cache[115] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Volume (m³)", -1)),
                        _createVNode(_component_Field, {
                          name: "volume",
                          modelValue: _ctx.nouvelleMarchandise.volume,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.nouvelleMarchandise.volume) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "volume",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_168, [
                        _cache[116] || (_cache[116] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Valeur déclarée "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "valeurDeclaree",
                          modelValue: _ctx.nouvelleMarchandise.valeurDeclaree,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.nouvelleMarchandise.valeurDeclaree) = $event)),
                          modelModifiers: { number: true },
                          type: "number",
                          step: "0.01",
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "valeurDeclaree",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_169, [
                        _cache[117] || (_cache[117] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Devise "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "devise",
                          modelValue: _ctx.nouvelleMarchandise.devise,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.nouvelleMarchandise.devise) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.deviseOptions,
                              searchable: true,
                              label: "label",
                              "track-by": "value",
                              valueProp: "value",
                              placeholder: "Sélectionner..."
                            }), null, 16, ["options"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "devise",
                          class: "text-danger small mt-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_170, [
                        _cache[119] || (_cache[119] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Pays d'origine", -1)),
                        _createVNode(_component_Field, {
                          name: "paysOrigine",
                          modelValue: _ctx.nouvelleMarchandise.paysOrigine,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.nouvelleMarchandise.paysOrigine) = $event))
                        }, {
                          default: _withCtx(({ field, setValue }) => [
                            _createVNode(_component_Multiselect, _mergeProps(field, {
                              options: _ctx.pays,
                              searchable: true,
                              loading: _ctx.loadingRefs,
                              placeholder: "Rechercher...",
                              label: "label",
                              "track-by": "value",
                              "onUpdate:modelValue": async (val) => {
                      setValue(val);
                      const paysObj = _ctx.pays.find(p => p.value === val);
                      if (paysObj?.iso2_code) {
                        const result = await _ctx.checkBlacklist('COUNTRY', paysObj.iso2_code);
                        _ctx.blacklistAlerts.paysOrigineMarchandise = result.isBlacklisted ? result.details : null;
                      } else {
                        _ctx.blacklistAlerts.paysOrigineMarchandise = null;
                      }
                    }
                            }), null, 16, ["options", "loading", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "paysOrigine",
                          class: "text-danger small mt-1"
                        }),
                        (_ctx.blacklistAlerts.paysOrigineMarchandise)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_171, [
                              _createElementVNode("small", null, [
                                _cache[118] || (_cache[118] = _createElementVNode("strong", null, "⚠️ ALERTE BLACKLIST:", -1)),
                                _createTextVNode(" Liste " + _toDisplayString(_ctx.blacklistAlerts.paysOrigineMarchandise.list_code) + " - " + _toDisplayString(_ctx.blacklistAlerts.paysOrigineMarchandise.reason), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_172, [
                        _cache[120] || (_cache[120] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Description complète "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "description",
                          modelValue: _ctx.nouvelleMarchandise.description,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.nouvelleMarchandise.description) = $event)),
                          as: "textarea",
                          rows: "2",
                          class: "form-control form-control-sm shadow-none fs-md-15 text-black",
                          placeholder: "ex: 2 véhicules Toyota Camry 2024, neufs, couleur blanche..."
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "description",
                          class: "text-danger small mt-1"
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_173, [
                    _createElementVNode("div", _hoisted_174, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "dupliquerMarchandise",
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.garderModalOuvert) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.garderModalOuvert]
                      ]),
                      _cache[121] || (_cache[121] = _createElementVNode("label", {
                        class: "form-check-label text-muted small",
                        for: "dupliquerMarchandise"
                      }, " Garder le formulaire rempli pour ajouter une autre marchandise ", -1))
                    ]),
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger",
                        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.fermerModalMarchandise && _ctx.fermerModalMarchandise(...args)))
                      }, " Annuler "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-success",
                        disabled: isSubmitting
                      }, _toDisplayString(isSubmitting ? 'Enregistrement...' : (_ctx.indexMarchandiseEnEdition !== null ? 'Modifier' :
                'Enregistrer')), 9, _hoisted_176)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.afficherModalMarchandisesConteneur)
      ? (_openBlock(), _createElementBlock("div", _hoisted_177))
      : _createCommentVNode("", true),
    (_ctx.afficherModalMarchandisesConteneur)
      ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
          _createElementVNode("div", _hoisted_179, [
            _createElementVNode("div", _hoisted_180, [
              _createElementVNode("div", _hoisted_181, [
                _createElementVNode("h5", _hoisted_182, [
                  _cache[122] || (_cache[122] = _createElementVNode("i", { class: "fas fa-container-storage me-2" }, null, -1)),
                  _createTextVNode(" Marchandises du conteneur " + _toDisplayString(_ctx.conteneurSelectionne?.numeroConteneur), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.fermerModalMarchandisesConteneur && _ctx.fermerModalMarchandisesConteneur(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_183, [
                (_ctx.conteneurSelectionne)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("div", _hoisted_186, [
                          _cache[123] || (_cache[123] = _createElementVNode("strong", null, "Conteneur :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.conteneurSelectionne.numeroConteneur), 1)
                        ]),
                        _createElementVNode("div", _hoisted_187, [
                          _cache[124] || (_cache[124] = _createElementVNode("strong", null, "Type :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.typeConteneurs.find(t => t.value === _ctx.conteneurSelectionne.typeConteneur)?.label || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_188, [
                          _cache[125] || (_cache[125] = _createElementVNode("strong", null, "Scellé :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.conteneurSelectionne.numeroScelle || 'N/A'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_189, [
                          _cache[126] || (_cache[126] = _createElementVNode("strong", null, "Poids :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.conteneurSelectionne.poidsBrut?.toFixed(2) || '0.00') + " tonnes ", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("h6", _hoisted_190, [
                  _cache[127] || (_cache[127] = _createElementVNode("i", { class: "fas fa-boxes me-2" }, null, -1)),
                  _createTextVNode(" Marchandises (" + _toDisplayString(_ctx.marchandisesConteneurSelectionne.length) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_191, [
                  _createElementVNode("table", _hoisted_192, [
                    _cache[131] || (_cache[131] = _createElementVNode("thead", { class: "table-light" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "N°"),
                        _createElementVNode("th", null, "Description"),
                        _createElementVNode("th", null, "Code HS"),
                        _createElementVNode("th", null, "Type Conditionnement"),
                        _createElementVNode("th", null, "Poids (Tonnes)"),
                        _createElementVNode("th", null, "Poids Net (Tonnes)"),
                        _createElementVNode("th", null, "Volume (m³)"),
                        _createElementVNode("th", null, "Valeur"),
                        _createElementVNode("th", null, "Devise"),
                        _createElementVNode("th", null, "Catégorie"),
                        _createElementVNode("th", null, "Actions")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marchandisesConteneurSelectionne, (marchandise, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, _toDisplayString(marchandise.originalIndex + 1), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_193, _toDisplayString(marchandise.description), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("small", _hoisted_194, _toDisplayString(typeof marchandise.hscode === 'object'
                          ? (marchandise.hscode?.label || `${marchandise.hscode?.code} - ${marchandise.hscode?.product}`)
                          : _ctx.hsCodes.find(h => h.value === marchandise.hscode)?.label || '-'), 1)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(marchandise.nombreColis) + " " + _toDisplayString(_ctx.typeConditionnements.find(t => t.value === marchandise.typeConditionnement)?.label || '-'), 1),
                          _createElementVNode("td", _hoisted_195, _toDisplayString(marchandise.poidsBrut?.toFixed(2) || '0.00'), 1),
                          _createElementVNode("td", _hoisted_196, _toDisplayString(marchandise.poidsNet?.toFixed(2) || '-'), 1),
                          _createElementVNode("td", _hoisted_197, _toDisplayString(marchandise.volume?.toFixed(2) || '-'), 1),
                          _createElementVNode("td", _hoisted_198, _toDisplayString(marchandise.valeurDeclaree?.toFixed(2) || '0.00'), 1),
                          _createElementVNode("td", null, _toDisplayString(marchandise.devise || 'USD'), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("small", _hoisted_199, _toDisplayString(typeof marchandise.categorieProduit === 'object'
                          ? ((marchandise.categorieProduit as any)?.label || `${(marchandise.categorieProduit as any)?.code} - ${(marchandise.categorieProduit as any)?.name}`)
                          : _ctx.categoriesProduit.find(c => c.value === marchandise.categorieProduit)?.label || '-'), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-primary btn-sm me-1",
                              onClick: ($event: any) => {_ctx.modifierMarchandise(_ctx.blIndex, marchandise.originalIndex); _ctx.fermerModalMarchandisesConteneur()},
                              title: "Modifier cette marchandise"
                            }, [...(_cache[128] || (_cache[128] = [
                              _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                            ]))], 8, _hoisted_200),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-outline-danger btn-sm",
                              onClick: ($event: any) => (_ctx.supprimerMarchandise(_ctx.blIndex, marchandise.originalIndex)),
                              title: "Supprimer cette marchandise"
                            }, [...(_cache[129] || (_cache[129] = [
                              _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                            ]))], 8, _hoisted_201)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", _hoisted_202, [
                      _createElementVNode("tr", null, [
                        _cache[130] || (_cache[130] = _createElementVNode("td", {
                          colspan: "4",
                          class: "text-end fw-bold"
                        }, "Total:", -1)),
                        _createElementVNode("td", _hoisted_203, _toDisplayString(_ctx.marchandisesConteneurSelectionne.reduce((sum, m) => sum + (m.poidsBrut || 0), 0).toFixed(2)) + " tonnes ", 1),
                        _createElementVNode("td", _hoisted_204, _toDisplayString(_ctx.marchandisesConteneurSelectionne.reduce((sum, m) => sum + (m.valeurDeclaree || 0), 0).toFixed(2)) + " USD ", 1),
                        _createElementVNode("td", _hoisted_205, _toDisplayString(_ctx.marchandisesConteneurSelectionne.length) + " marchandise(s) ", 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_206, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.fermerModalMarchandisesConteneur && _ctx.fermerModalMarchandisesConteneur(...args)))
                }, " Fermer ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}